export const PermissionService = {
    get: () => {
        const data = localStorage.getItem("permissions");
        return data ? JSON.parse(data) : [];
    },

    has: ({ category, page, type }) => {
        const role = localStorage.getItem("role");

        // ✅ Employee role me hi permission check karo
        if (role && role.toUpperCase() === "EMPLOYEE") {
            const perms = PermissionService.get();

            return perms.some((p) => {
                if (p.category === category && p.page === page) {
                    // 🔹 If WRITE hai to READ bhi allowed
                    if (p.permission === "WRITE" && type === "WRITE") {
                        return true; // full access
                    }
                    // 🔹 Otherwise check exact match
                    return p.permission === type;
                }
                return false;
            });
        }

        // ✅ Other roles ke liye by default true
        return true;
    },
};
